import script from "./SlideImagesBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideImagesBlock.vue?vue&type=script&setup=true&lang=ts"

import "./SlideImagesBlock.vue?vue&type=style&index=0&id=6054d42d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6054d42d"]])

export default __exports__